import React, { FunctionComponent } from 'react';
import ReactModal from 'react-modal';
import Media from 'react-media';
import styled from 'styled-components';

import { SCREEN } from 'scenes/common/types/screen';

import { HtmlParserType } from 'scenes/common/helpers/html';
import { Button, Heading, Icon } from './chroma';

const CloseButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  .c-btn {
    padding: 1rem;
  }
  z-index: 1;
`;

interface ModalProps {
  header?: string;
  isOpen: boolean;
  headerElement?: HtmlParserType;
  onClose: () => void;
  answerRequired?: boolean;
  styles?: object;
}

export const Modal: FunctionComponent<ModalProps> = ({
  headerElement,
  isOpen,
  onClose,
  children,
  header,
  answerRequired,
  styles,
}) => (
  <Media query={{ maxWidth: SCREEN.MEDIUM }}>
    {(matches) => (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel={header}
        style={{
          content: {
            top: '15%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: '40rem',
            maxWidth: '90%',
            maxHeight: '80%',
            transform: 'translate(-50%)',
            fontSize: '1.2rem',
            borderRadius: '0.3rem',
            padding: matches ? '20px' : '40px',
            ...styles,
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, .6)',
            zIndex: 1000,
          },
        }}
        ariaHideApp={false}
      >
        {!answerRequired && (
          <CloseButton>
            <Button tertiary onClick={onClose} ariaLabel="Close dialog button">
              <Icon name="times" fontSize={22} ariaLabel="Close dialog icon" />
            </Button>
          </CloseButton>
        )}
        {(headerElement || header) && (
          <Heading size={1} textAlign="left" margin={{ top: 2 }}>
            {headerElement ?? header}
          </Heading>
        )}
        {children}
      </ReactModal>
    )}
  </Media>
);

export default Modal;
